import React from 'react';
import { Icon } from './Icon.js';
export const IconFolderPen2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M17 15L22.5 9.5L19.5 6.5L14 12V15H17Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M6 15L10 15", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M13.4141 5H16.7568L14.7568 7H12.5859L9.58594 4H3V19H21V15.2441L23 13.2441V21H1V2H10.4141L13.4141 5Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconFolderPen2.js.map